/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MitarbeiterInfosDto } from '../../models/mitarbeiter-infos-dto';

export interface GetAllMitarbeiterAggregated$Plain$Params {
  Units?: Array<string>;
  Kostenstelle?: string;
  TarifAttribut?: string;
  AttributId?: string;
  Monat?: string;
  Saldovortrag?: boolean;
}

export function getAllMitarbeiterAggregated$Plain(http: HttpClient, rootUrl: string, params?: GetAllMitarbeiterAggregated$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<MitarbeiterInfosDto>> {
  const rb = new RequestBuilder(rootUrl, getAllMitarbeiterAggregated$Plain.PATH, 'get');
  if (params) {
    rb.query('Units', params.Units, {});
    rb.query('Kostenstelle', params.Kostenstelle, {});
    rb.query('TarifAttribut', params.TarifAttribut, {});
    rb.query('AttributId', params.AttributId, {});
    rb.query('Monat', params.Monat, {});
    rb.query('Saldovortrag', params.Saldovortrag, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MitarbeiterInfosDto>;
    })
  );
}

getAllMitarbeiterAggregated$Plain.PATH = '/v1/mitarbeiter/aggregated';
